module.exports = __webpack_public_path__ + "media/images/dummy-content/user-3-b1e6a273e0ccbb5ee0ed66f30ebcc3b7.jpg";